import angularGridRenderers from './AngularGrid/renderers'
import angularGridTemplates from './AngularGrid/templates'
import angularGridValueGetters from './AngularGrid/valueGetters'

import filtersDateFormat from './Filters/dateFormat'
import filtersPercent from './Filters/percent'

import collection from './collection'
import httpDecorator from './httpDecorator'
import { run as defaultModelOptions } from './modelOptions'

import { vsName as defaultValuesProviderName, DefaultValuesProvider } from './defaultValues/provider'

import simpleQuery from './server/simpleQuery'
import simplePutOrPostSave from './server/simplePutOrPostSave'
import simpleDelete from './server/simpleDelete'

var mod = angular.module('SlotTrak.Utils', [])
  .config(httpDecorator)
  .run(defaultModelOptions)
  .factory('angularGridRenderers', angularGridRenderers)
  .value('angularGridTemplates', angularGridTemplates)
  .value('angularGridValueGetters', angularGridValueGetters)
  .filter('dateFormat', filtersDateFormat.short)
  .filter('longDateFormat', filtersDateFormat.long)
  .filter('percent', filtersPercent)
  .factory('collection', collection)
  .factory(simpleQuery.vsName, simpleQuery)
  .factory(simplePutOrPostSave.vsName, simplePutOrPostSave)
  .factory(simpleDelete.vsName, simpleDelete)
  .provider(defaultValuesProviderName, DefaultValuesProvider)


export default mod.name